import React, { useEffect, useState } from "react";
import "./OffersPage.css";
import { useSelector, useDispatch } from "react-redux";
import { setOffers } from "../../../../../store/app/appReducer";
import callApi from "../../../../../utility/apiCaller";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { setUserClickData } from "../../../../../utility/setUserClickData";
import OfferCard from "./OfferCard";
import { TRACK_ID } from "../../../../../utility/enum";
import { useSearchParams } from "react-router-dom";
import _ from "lodash";
import { getAllianceLeadFromMoneyTapInput } from "../../../../../utility/commonUtils";
const OfferPage = ({ formData, setShowOfferHeaderLogo }) => {
  const lead = useSelector((state) => state.app.lead);
  const user = useSelector((state) => state.app.user);
  const offers = useSelector((state) => state.app.offers);
  const dispatch = useDispatch();
  const [isFinished, setIsFinished] = useState(false);
  const [leadId, setLeadId] = useState();
  const [expandedOfferId, setExpandedOfferId] = useState(null);
  const [activeLenders, setActiveLenders] = useState([]);
  const [params] = useSearchParams();
  const [isTncChecked, setIsTncChecked] = useState(true);
  const mobile = formData?.mobile || "";
  const navigate = useNavigate();
  const [source, setSource] = useState("");
  const token = user?.token;
  const [failedList, setFailedList] = useState([]);

  const lenderOrder = [
    "662752eb65fdba1a48d6e482",
    "687882db884a4422ccafa173", // IndusInd missing
    "67ef646df80610d286084e60",
    "662752eb65fdba1a48d6e464",
    "666ec1953a9a969d8f9980f1",
    "6855600d0313d8d083045d13",
    "662752eb65fdba1a48d6e474",
    "6851271c3a9753dd00d85475",
    "68b7cb3721c19b150d2893da", // Creditsea missing
  ];
  console.log(offers);
  const lenderNames = [
    "L&T",
    "IndusInd",
    "Hero",
    "MV",
    "Kissht",
    "Raam Fincorp",
    "TrueBalance",
    "Fatakpay",
    "Creditsea",
  ];
  const [ipAddress, setIpAddress] = useState("");

  const sortedOffers = [...offers].sort((a, b) => {
    const indexA = lenderOrder.indexOf(a.lender_id);
    const indexB = lenderOrder.indexOf(b.lender_id);

    // If lender_id is not in sequence, place it at the end
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });

  async function fetchIp() {
    await fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        // ipAddress = data?.ip;
        setIpAddress(data?.ip);
        console.log("IP Address:", data?.ip);
        console.log(ipAddress);
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  }
  useEffect(() => {
    fetchIp();
  }, []);

  useEffect(() => {
    fetchActiveLenders();
  }, []);

  useEffect(() => {
    // if (formData.stepDone === 3 && !leadId) {
    submitLead();
    // }
  }, [formData]);

  useEffect(() => {
    if (offers.length > 0 && !expandedOfferId) {
      setExpandedOfferId(offers[0]._id);
    }
  }, [offers]);

  useEffect(() => {
    if (offers.length > 0) {
      setShowOfferHeaderLogo(false);
    }
  }, [offers]);

  const fetchActiveLenders = async () => {
    try {
      const res = await callApi(`v1/lender/active-lenders`, "get", {}, "loan");
      if (res.status === "Success") {
        const apiLenders = res.data.lenderList ?? [];

        // const hardcodedLender = {
        //   _id: "662752eb65fdba1a48d6e482",
        //   lender_name: "L&T",
        // };

        const mergedLenders = [...apiLenders];

        setActiveLenders(mergedLenders);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const submitLead = async () => {
    setUserClickData({
      event_name: "professional-details-submit-for-old-lead-campaign",
      user_id: formData.mobile || "No User ID found here",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
      utm_source: params.get("utm_source") || params.get("utm_medium") || "",
    });
    try {
      const trackId = localStorage.getItem(TRACK_ID);
      const processedLead = getAllianceLeadFromMoneyTapInput(
        "website-pl-old-lead",
        {
          ...formData,
          ...user,
        }
      );
      console.log("Processed Lead: ", processedLead);
      const res = await callApi(
        "v1/lead/pa_lead_check",
        "post",
        {
          lead: {
            ...processedLead,
            tracking_id: trackId,
            aff_id: params.get("aff_id"),
            utm_source: params.get("utm_source"),
            source: params.get("source"),
            utm_medium: params.get("utm_medium"),
            utm_term: params.get("utm_term"),

            // ✅ Add from formData
            ownership_type: formData.ownership,
            loan_purpose: formData.loan_purpose,
          },
        },
        "core",
        user.token
      );

      if (res.status === "Success" && res.data.lead) {
        const newLeadId = res.data.lead._id;
        const contactPhone = res.data.lead.contact_phone;
        setLeadId(newLeadId);

        // fetch existing lender api-calls + lenders meta once (we'll use these for pushes)
        const ltResponse = await callApi(
          "v1/lender_api_call/list",
          "post",
          {
            filters: {
              lead_id: newLeadId,
              lender_name: {
                $in: ["L&T", "Agrim"],
              },
            },
            pageSize: 10,
            pageNum: 1,
          },
          "loan_service"
        );

        const lendersData = await callApi(
          "v1/lender/list",
          "post",
          {
            filters: {
              name: { $in: ["L&T", "Agrim"] },
            },
            pageSize: 10,
            pageNum: 1,
          },
          "loan_service",
          token
        );

        // safe helpers
        const hasLenderCall = (name) =>
          (ltResponse?.data?.lender_api_callList || []).some(
            (entry) => entry.lender_name === name
          );

        const getLenderMeta = (name) =>
          (lendersData?.data?.lenderList || []).find((l) => l.name === name) ||
          null;

        // push L&T if needed (initial push before polling)
        const ltMeta = getLenderMeta("L&T");
        if (
          !hasLenderCall("L&T") &&
          ltMeta &&
          ltMeta.otp_page_api_push === true
        ) {
          console.log("Calling bulk-lead-push-by-leadId for L&T", {
            leads: [{ lead_id: newLeadId }],
            lender_name: "L&T",
            lender_id: ltMeta._id || "662752eb65fdba1a48d6e482",
          });

          await callApi(
            "v1/lead/bulk-lead-push-by-leadId",
            "post",
            {
              leads: [{ lead_id: newLeadId }],
              lender_name: "L&T",
              lender_id: ltMeta._id || "662752eb65fdba1a48d6e482",
            },
            "core",
            token
          );
        }

        // Poller (recursive setTimeout) — no overlapping calls, deterministic stop
        const pollOffers = async (
          leadIdToPoll,
          attempt = 1,
          maxAttempts = 6
        ) => {
          if (!leadIdToPoll || isFinished) return;

          try {
            const found = await fetchOffers(leadIdToPoll);
            if (found) return; // success: fetchOffers sets isFinished(true) internally

            if (attempt < maxAttempts) {
              // schedule next attempt after 5s
              setTimeout(
                () => pollOffers(leadIdToPoll, attempt + 1, maxAttempts),
                5000
              );
              return;
            }

            // reached maxAttempts: do final fallback (push HDB if needed), then one final fetch
            const hdbMeta = getLenderMeta("Agrim");
            // console.log("hbdmeta", hdbMeta);
            // console.log("Checking Agrim push conditions...");

            // console.log("hasLenderCall('Agrim') =", hasLenderCall("Agrim"));
            // console.log("hdbMeta =", hdbMeta);
            // console.log(
            //   "hdbMeta?.otp_page_api_push =",
            //   hdbMeta?.otp_page_api_push
            // );
            // if (
            //   !hasLenderCall("Agrim") &&
            //   hdbMeta &&
            //   hdbMeta.otp_page_api_push === true
            // ) {
            //   console.log("Calling bulk-lead-push-by-leadId for Agrim", {
            //     leads: [{ lead_id: leadIdToPoll }],
            //     lender_name: "Agrim",
            //     lender_id: hdbMeta._id || "68c7af17f7adc14a17e46baf",
            //   });

            //   await callApi(
            //     "v1/lead/bulk-lead-push-by-leadId",
            //     "post",
            //     {
            //       leads: [{ lead_id: leadIdToPoll }],
            //       lender_name: "Agrim",
            //       lender_id: hdbMeta._id || "68c7af17f7adc14a17e46baf",
            //     },
            //     "core",
            //     token
            //   );

            //   // give the lender a short moment to process
            //   await new Promise((r) => setTimeout(r, 1500));
            // }

            // One final attempt after HDB push (or if HDB not applicable)
            const finalFound = await fetchOffers(leadIdToPoll);
            if (!finalFound) {
              // No offers found even after final attempt -> mark finished so UI shows no-offers
              setIsFinished(true);
            }
          } catch (err) {
            console.error("Error while polling offers", err);
            setIsFinished(true);
          }
        };

        // start polling (first immediate attempt included inside pollOffers)
        pollOffers(newLeadId, 1, 6);
      }
    } catch (err) {
      toast("Some error occurred", { hideProgressBar: true, type: "error" });
      console.log(err);
    }
  };

  const fetchOffers = async (leadId) => {
    if (!leadId || isFinished) return false;

    try {
      // 1️⃣ Fetch offers for the lead
      const res = await callApi(
        `v1/loan_offer/lead_id/${leadId}`,
        "get",
        {},
        "core",
        user.token
      );

      if (res.status === "Success" && res.data?.offers?.length > 0) {
        console.log(res);

        // 2️⃣ Update offer priority
        const priorityRes = await callApi(
          `v1/finbud_data/finbud_update_priority/${leadId}`,
          "post",
          res,
          "loan",
          user.token
        );

        if (
          priorityRes.status === "Success" &&
          Array.isArray(priorityRes.data?.offers)
        ) {
          const offers = priorityRes.data.offers;

          // ✅ 3️⃣ Fetch NEW Successlist lender data
          const lenderListRes = await callApi(
            `v1/lender_api_call/${leadId}/get-fail-success-lenders`,
            "post",
            {},
            "loan",
            user.token
          );
          if (Array.isArray(lenderListRes.data?.FailList)) {
            setFailedList(lenderListRes.data?.FailList);
          }

          // ✅ 4️⃣ Build lender map from Successlist
          let lenderMap = {};
          if (
            lenderListRes.status === "Success" &&
            Array.isArray(lenderListRes.data?.Successlist)
          ) {
            lenderMap = Object.fromEntries(
              lenderListRes.data.Successlist.map((lender) => [
                lender.lender_id,
                lender,
              ])
            );
          }

          // ✅ 5️⃣ Enrich each offer with lender details from Successlist
          const enrichedOffers = offers.map((offer) => {
            const lender = lenderMap[offer.lender_id] || {};

            return {
              ...offer,
              apr: lender.apr ?? "",
              kfs_doc: lender.kfs_doc ?? "",
              credit_limit: lender.web_offer ?? "",
              penal_charges: lender.penal_charges ?? "",
              processing_fee: lender.processing_fee ?? "",
              interest_rate: lender.web_interest ?? null, // ✅ updated name
              lender_name: lender.lender_name ?? offer.lender_name,
            };
          });

          // ✅ 6️⃣ Sort by priority
          const sortedOffers = _.orderBy(enrichedOffers, ["priority"], ["asc"]);

          // ✅ 7️⃣ Filter by active lenders if any
          const filteredOffers = activeLenders.length
            ? sortedOffers.filter((offer) =>
                activeLenders.some((lender) => lender._id === offer.lender_id)
              )
            : sortedOffers;

          // ✅ 8️⃣ Dispatch final enriched offers
          dispatch(setOffers(filteredOffers));

          // ✅ 9️⃣ Update finished state
          if (priorityRes.data.lead?.all_responses) {
            setIsFinished(
              priorityRes.data.lead.all_responses ===
                priorityRes.data.lead.total_response
            );
          } else {
            setIsFinished(true);
          }

          return true;
        }
      }

      return false;
    } catch (err) {
      console.error("Error in offer fetching", err);
      toast.error("Something went wrong while fetching offers.");
      setIsFinished(true);
      return false;
    }
  };

  return (
    <div id="offer-page-v5">
      {offers.length > 0 ? (
        <>
          <div className="final-offers-container-v5">
            <>
              {/* <video
                className="background-video1"
                src="/assets/img/BG video.mp4"
                autoPlay
                loop
                muted
              /> */}
              <img
                src="/assets/img/Offer page BG image 1.png"
                alt="Square Check Background"
                className="background-overlay-img-offer"
              />
            </>
            <div className="offer-bg-layer-v5">
              <h2 className="congrats-text1">Congratulations!</h2>
              <h3 className="sub-text1">You’re Pre-Qualified for</h3>
              <h3 className="sub-text1">a Personal Loan!</h3>
            </div>
          </div>

          <div className="offer-cards-container-new1">
            {sortedOffers.map((offer) => (
              <OfferCard
                key={offer._id}
                offer={offer}
                isExpanded={expandedOfferId === offer._id}
                onExpand={() => setExpandedOfferId(offer._id)}
              />
            ))}

            <div
              className="p-4 rounded-xl bg-white-900/80  backdrop-blur-md shadow-lg mx-2"
              style={{ backgroundColor: "white" }}
            >
              {/* Note Header */}
              <div className="flex items-center gap-2 mb-2">
                <span className="text-xs font-semibold uppercase tracking-wide text-red-500">
                  Note
                </span>
              </div>

              {/* Note Text */}
              <p className="text-sm text-black-300 mb-4 leading-relaxed">
                {failedList?.length > 0 && (
                  <p className="text-sm text-black-300 mb-2">
                    There are no matching offers for your request from:{" "}
                    {failedList.join(", ")}
                  </p>
                )}
              </p>
            </div>
            <p className="disclaimer-offer-new-text-v5">
              Choose from these incredible offers that best suit your needs
            </p>
            <p className="disclaimer-text1">
              *These pre-approved offers are subject to change at discretion of
              Bank / NBFC after receiving all your documents and details. Final
              offer will be based on risk policy of Bank / NBFC. We do not
              guarantee that final offer will be same as Pre-approved offer.
            </p>
          </div>
        </>
      ) : isFinished ? (
        setShowOfferHeaderLogo(true) || (
          <div className="no-offers-found">
            <h2 className="congrats-text">
              There is no offer for you currently.
            </h2>
          </div>
        )
      ) : (
        setShowOfferHeaderLogo(true) || (
          <div className="no-offers-found">
            <h2 className="congrats-text">
              Please wait while we are searching best offers for you
            </h2>
          </div>
        )
      )}
    </div>
  );
};

export default OfferPage;
